export default __webpack_public_path__ + "static/media/NotoSans-Medium.5d12b311.eot";